import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import InteractiveRobot from "./InteractiveRobot";

const Banner = () => {
  const [animatedElements, setAnimatedElements] = useState({
    name: false,
    role: false,
    bio: false,
    cta: false,
  });

  useEffect(() => {
    // Staggered animations for elements
    const timers = [
      setTimeout(
        () => setAnimatedElements((prev) => ({ ...prev, name: true })),
        500
      ),
      setTimeout(
        () => setAnimatedElements((prev) => ({ ...prev, role: true })),
        1000
      ),
      setTimeout(
        () => setAnimatedElements((prev) => ({ ...prev, bio: true })),
        1500
      ),
      setTimeout(
        () => setAnimatedElements((prev) => ({ ...prev, cta: true })),
        2000
      ),
    ];

    return () => timers.forEach((timer) => clearTimeout(timer));
  }, []);

  return (
    <section
      id="home"
      className="w-full py-24 md:py-28 lg:py-36 section-divider"
    >
      <div className="max-w-screen-xl mx-auto flex flex-col-reverse md:flex-row">
        {/* Left Column - Text Content */}
        <div className="md:w-[45%] lg:w-[50%] flex flex-col justify-center mt-12 md:mt-0">
          <h1 className="text-3xl md:text-4xl lg:text-5xl mb-4">
            {/* Animated name with each letter appearing */}
            {"Imtiaz Pranto".split("").map((letter, index) => (
              <span
                key={index}
                className="inline-block transition-all duration-700"
                style={{
                  opacity: animatedElements.name ? 1 : 0,
                  transform: animatedElements.name
                    ? "translateY(0)"
                    : `translateY(${Math.random() * 50 - 25}px)`,
                  transitionDelay: `${index * 60}ms`,
                }}
              >
                {letter === " " ? "\u00A0" : letter}
              </span>
            ))}
          </h1>

          <h2
            className="font-medium text-[#8A00D4] text-xl md:text-2xl mt-[10px] leading-[1.3] tracking-wide transition-all duration-1000"
            style={{
              opacity: animatedElements.role ? 1 : 0,
              filter: animatedElements.role ? "blur(0)" : "blur(4px)",
            }}
          >
            AI Product Strategist
          </h2>

          <p
            className="font-sans font-normal text-lightText text-base leading-relaxed mb-8 mt-[30px] max-w-[60ch] transition-all duration-1000"
            style={{
              opacity: animatedElements.bio ? 1 : 0,
              transform: animatedElements.bio
                ? "translateY(0)"
                : "translateY(20px)",
            }}
          >
            Dynamic Product Management professional specializing in AI-driven
            solutions for e-Commerce and SaaS platforms. I leverage Computer
            Science expertise and business acumen to deliver innovative products
            that enhance user engagement and drive growth.
          </p>

          <div
            className="mt-[40px] transition-all duration-500"
            style={{
              opacity: animatedElements.cta ? 1 : 0,
              transform: animatedElements.cta
                ? "translateY(0)"
                : "translateY(30px)",
            }}
          >
            <a
              href="/resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-gradient-to-r from-[#4B006E] to-[#8A00D4] text-white rounded-md shadow-[0_0_15px_rgba(138,0,212,0.5)] hover:shadow-[0_0_25px_rgba(138,0,212,0.7)] transition-all duration-300 cursor-pointer"
            >
              Download Resume
            </a>
          </div>
        </div>

        {/* Right Column - Spline Robot */}
        <div className="md:w-[55%] lg:w-[50%] md:ml-[60px] lg:ml-[80px] flex justify-center items-center robot-container">
          <InteractiveRobot />
        </div>
      </div>
    </section>
  );
};

export default Banner;
